module.exports = __webpack_public_path__ + "static/media/recipe_icon.71daae53.png";